import styles from "./exponentLabel.module.scss";

export const ExponentLabel = (props) => {
  const { children, style } = props;
  return (
    <div className={styles.exponent_label} style={style}>
      {children}
    </div>
  );
};
